import React, { useRef } from "react";
import { Link } from "react-router-dom";

import ToolTip from "@app/components/2_widgets/ToolTip";
import CustomModal from "@app/components/2_widgets/CustomModal";

import ButtonPrimary from "@app/components/1_elements/ButtonPrimary";
import ButtonSecondary from "@app/components/1_elements/ButtonSecondary";

import { useToast } from '@app/components/3_modules/ToastContainer';
// import TextInput from "../1_elements/input/TextInput";
import Input from "../1_elements/Input";
import InputText from "../2_widgets/inputs/InputText";
import InputPhone from "../2_widgets/inputs/InputPhone";
import InputEmail from "../2_widgets/inputs/InputEmail";
import InputPassword from "../2_widgets/inputs/InputPassword";
import PasswordConfirmationInputGroup from "../3_modules/PasswordConfirmationInputGroup";
import InputTextArea from "../2_widgets/inputs/InputTextArea";
import InputDate from "../2_widgets/inputs/InputDate";
import InputCheckbox from "../2_widgets/inputs/InputCheckbox";
import InputRadio from "../2_widgets/inputs/InputRadio";
import SelectList from "../2_widgets/SelectList";
import Table from "../2_widgets/Table";
import TableContent from "../1_elements/TableContent";

export default function HomeTemplate() {
    const refModal = useRef();
    const refEmail = useRef();

    const toast = useToast();  

    const tableData = [
        {title: "Titre n°1", status: "in_progress", created_at: "2026-02-11"},
        {title: "Titre n°2", status: "closed", created_at: "2026-01-01"},
    ]

    /** Table config */
    const selectedColumns = [        
        {key: "title", label: "Référent", sortable: true}, 
        {key: "status", label: "Statut", sortable: true, type: "badge", translatable: true}, 
        {key: "created_at", label: "Soumis le", type: "date", sortable: true},
        // {key: "buttons", label: "Actions", onlyButtons: true, buttons: rowButtons },        
    ]    
    let filters = [        
        {
            key: "status", 
            label: "Filtre Statut", 
            options: [
                {value: "all", label: "Tous"}, 
                {value: "in_progress", label: "En cours"}, 
                {value: "closed", label: "Clôturé"}, 
            ]
        },      
    ]


    function displayModal(event) {
        event.preventDefault();
        refModal.current.displayModal(
            "Titre de la modal",
            "Description de la modal",
            "Confirmer",
            "Annuler",
            () => console.log("click Modal!")
        )
    }

    return (
        <div>
            {/** Content test */}
            <h1>Tag H1 - Lorem</h1>
            <h2>Tag H2 - Lorem</h2>
            <h3>Tag H3 - Lorem</h3>
            <div>Tag DIV - lorem</div>
            <span>Tag SPAN - lorem</span>
            <p>Tag P - lorem</p><br/>
            <Link to="#">Tag a - lorem</Link><br/>
            <b>Tag bold - lorem</b><br/>
            <strong>Tag strong - lorem</strong><br/>

            {/** Buttons */}
            <div className="mt-3">
                <ButtonPrimary label="Bouton Primaire" onClick={() => console.log("btn primary!")}/>
                <ButtonSecondary label="Bouton Secondaire" onClick={() => console.log("btn secondary!")}/>                
            </div>

            {/** Badges */}
            <div>
                <span className="badge-draft">Brouillon</span>
                <span className="badge-in_progress">En cours</span>
                <span className="badge-closed">Clôturé</span>
            </div>

            {/** Tool Tip display */}
            <div className="mt-3">
                <ToolTip 
                    title="Ceci est un exemple ToolTip"
                    description="Contenu de la description d'un tooltip"
                />
            </div>

            <div className="mt-3">
                {/* Alert Notification */}
                <button className="custom-btn-primary" onClick={displayModal}>Display Modal</button>
                <CustomModal ref={refModal} />
            </div>

            {/** Toast system */}
            <div className="mt-3">
                <button className="custom-btn-secondary" onClick={() => toast.addToast("Titre Toast", "Description Toast")}>Display Toast</button>
            </div>

            {/** INPUTS */}
            <div className="mt-3">
                <InputText
                    ref={refEmail}
                    inputId="text-input"
                    label="Prénom Nom"
                    isRequired={true}
                    placeholder="prénom"
                    tooltip={{title: "Tool Tip", desc: "Description du tool"}}
                />
                <InputPhone 
                    inputId="phone"
                    label="N° de téléphone"
                    isRequired={true}
                    placeholder="phone number"
                    tooltip={{title: "Tool Tip", desc: "Description du tool"}}
                />
                <InputEmail 
                    inputId="email"
                    label="Votre email"
                    isRequired={true}
                    placeholder="email"
                    tooltip={{title: "Tool Tip", desc: "Description du tool"}} 
                />
                <InputPassword
                    inputId="password"
                    label="Votre mdp"
                    isRequired={true}
                    placeholder="password"
                    tooltip={{title: "Tool Tip", desc: "Description du tool"}} 
                />
                <PasswordConfirmationInputGroup
                    isRequired={true}
                />
                <InputTextArea
                    inputId="text area"
                    label="Text area"
                    isRequired={true}
                    placeholder="teaxt-area"
                    tooltip={{title: "Tool Tip", desc: "Description du tool"}} 
                />
                <InputDate 
                    inputId="date"
                    label="Date"
                    isRequired={true}
                    placeholder="date"
                    tooltip={{title: "Tool Tip", desc: "Description du tool"}}                 
                />
                <InputCheckbox
                    label="En cliquant ici, vous acceptez les CGV"
                    inputValue="cgv"
                />
                <InputRadio
                    label="Êtes-vous inscrit sur la Newsletter ?" 
                    isRequired={true} 
                    options={[{label:"Oui", value:true}, {label:"Non", value:false}]}
                    inputId="input-newsletter"
                    defaultValue={false}
                />
                <SelectList                    
                    label="Menu des actions de validations"
                    options={[
                        {value: "validated", label: "Valider l'inscription"}, 
                        {value: "correction_waiting", label: "Demander une correction"}, 
                        {value: "pending_superadmin", label: "Transférer la fiche à l'Administrateur"},
                        {value: "refused", label: "Refuser l'inscription"}
                    ]}
                    isMulti={true}
                />
                <div className="row">
                    <div className="col-10">
                        <Table data={tableData} columns={selectedColumns} filters={filters}>
                            <TableContent />
                        </Table>
                    </div>
                </div>
            </div>
        </div>
    );
}